import React, { useEffect, useRef, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useField } from "formik";

import { toCents, fromCents } from "../utils/money";

function MoneyField({ name, label, currencyCode, placeholder, disabled }) {
    const [field, meta, helpers] = useField(name);
    const cents = Number(field.value || 0);

    const [display, setDisplay] = useState(fromCents(cents));
    const isEditingRef = useRef(false);

    useEffect(() => {
        if (isEditingRef.current) return;
        setDisplay(fromCents(cents));
    }, [cents]);

    return (
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>

            <InputGroup>
                <Form.Control
                    id={name}
                    name={name}
                    type="text"
                    inputMode="decimal"
                    value={display}
                    placeholder={placeholder}
                    disabled={disabled}
                    isInvalid={meta.touched && !!meta.error}
                    onFocus={() => {
                        isEditingRef.current = true;
                    }}
                    onChange={(e) => {
                        let v = e.target.value.replace(",", ".");

                        if (!/^\d*\.?\d*$/.test(v)) return;

                        const parts = v.split(".");
                        if (parts[1] && parts[1].length > 2) return;

                        setDisplay(v);
                    }}
                    onBlur={() => {
                        isEditingRef.current = false;
                        helpers.setTouched(true);

                        const raw = (display ?? "").trim();
                        if (raw === "" || raw === ".") {
                            helpers.setValue(0, false);
                            setDisplay("0.00");
                            return;
                        }

                        const centsValue = toCents(raw);
                        helpers.setValue(centsValue, false);
                        setDisplay(fromCents(centsValue));
                    }}
                />

                <InputGroup.Text>{currencyCode || "EUR"}</InputGroup.Text>

                <Form.Control.Feedback type="invalid">
                    {meta.error}
                </Form.Control.Feedback>
            </InputGroup>
        </Form.Group>
    );
}

export default MoneyField;